import { IErrorReason } from "../appointmentForm.machine";

export function resolveAppointmentCodeError(
  errorCode: string | undefined,
): IErrorReason {
  if (errorCode === "INVALID_APPOINTMENT_CODE") {
    return "APPOINTMENT_UNAVAILABLE";
  }

  if (errorCode === "APPOINTMENT_SLOT_TAKEN") {
    return "APPOINTMENT_SLOT_TAKEN";
  }

  return "ERROR";
}
